export default __webpack_public_path__ + "static/media/frontdesk-reservations.5198356c.jpg";